









































import { User, Global, Reports, Projects } from '@/store';
import Vue from 'vue';
import Component from 'vue-class-component';
import DevicesListTable from '@/components/DevicesListTable.vue';
import API, { Types } from '@/modules/API';
import MessageDialog from '@/components/dialogs/MessageDialog.vue';
import LoadingDialog from '@/components/dialogs/LoadingDialog.vue';
import moment from 'moment-timezone';
import Utils from '@/modules/Utils';

@Component({
    components: { 
        DevicesListTable, 
        MessageDialog,
        LoadingDialog
    }
})

class ChangeDeviceStatus extends Vue {
    @User.State('project') project;
    @Global.State('readonly_user') readonly_user;
    @Global.State('lang') lang;
    @Global.Mutation('setPageTitle') setPageTitle;
    @Reports.Getter('commissioned_map') commissioned_map;
    @Reports.Getter('commissionedFixtures') commissionedFixtures;
    @Projects.State('projects_metadata') projects_metadata;

    selectedDevices = [];
    mode = 1;
    isLoadingDialogOpen = false;
    isMessageDialogOpen = false;
    message = 'You must choose at least one item in table';

    mounted(){
        this.setPageTitle('Device Status');
    }

    get has_retrofit_devices(){
        return this.commissionedFixtures.some((device) => !Utils.isDeviceLive(device));
    }

    get deviceModes(){
        return [
            { text: this.$t('Connected'), value: 1},
            { text: this.$t('Fault In Care'), value: -9}, 
            { text: this.$t('Maintenance'), value: -1}
        ];
    }

    updateSelected(selected){
        this.selectedDevices = [...selected];
    }

    async handleChangeClicked(){
        if (!this.selectedDevices.length) {
            this.isMessageDialogOpen = true;
            return;
        }

        this.isLoadingDialogOpen = true;
        let isCompleted = true;

        const slices = Math.ceil(this.selectedDevices.length / 100);
        let startIndex = 0, endIndex = Math.min(this.selectedDevices.length, 100);
        for (let i = 0; i < slices; i++){
            const current = this.selectedDevices.slice(startIndex, endIndex);
            await Promise.all(current.map( async (device) => {
                try {
                    const device_on_store = this.commissioned_map.get(device.id);
                    // Safety net for a device that entered Retrofit after it was
                    // selected - the table already blocks selecting those.
                    if (device_on_store && !Utils.isDeviceLive(device_on_store)) {
                        return;
                    }
                    // Skip API call if device status hasn't changed
                    if (device_on_store && device_on_store.sys___active === this.mode) {
                        return;
                    }
                    
                    const response = await this.updateDeviceMode(device.id, this.mode);
                    if (response.ok) {
                        if (device_on_store) {
                            this.updateDeviceModeOnStore(device_on_store);
                        }
                    }
                }catch (e){
                    isCompleted = false;
                }
            }));
            startIndex = endIndex;
            endIndex = Math.min(this.selectedDevices.length, endIndex + 100);
        }

        this.updateSelected([]);

        this.isLoadingDialogOpen = false;
        this.notifyStatus(isCompleted);
    }     

    updateDeviceMode(device_id, mode){
        return API.post('', `${Types.PROJECTS}/${this.project.id}/${Types.DEVICES}/${device_id}/streams/sys___active/evt/`, { content: mode }, {}, 'v4');
    }

    updateDeviceModeOnStore(device){
        const prev_status = Utils.getDeviceStatus(device);

        device.sys___active = this.mode;
        // Set 10-digit UTC timestamp (seconds)
        device.sys___active__modified = Math.floor(Date.now() / 1000);

        const new_status = Utils.getDeviceStatus(device);
        const activity_chart = this.projects_metadata.get(this.project.id).device_state_metrics;
        
        // Handle both old format (number) and new format (object with count and name)
        if (typeof activity_chart[prev_status] === 'object' && activity_chart[prev_status] !== null) {
            activity_chart[prev_status].count -= 1;
        } else {
            activity_chart[prev_status] -= 1;
        }
        
        if (typeof activity_chart[new_status] === 'object' && activity_chart[new_status] !== null) {
            activity_chart[new_status].count += 1;
        } else {
            activity_chart[new_status] += 1;
        }
    }

    notifyStatus(isCompleted){
        const notifyData = isCompleted 
            ? {
                text: 'Devices mode updated successfully!',
                type: 'success',
                title: 'Success!'
            } : {
                text: 'Some mode devices could not update. Please try again later.',
                type: 'error',
                title: 'Error!'
            };
        
        this.$notify(notifyData);
    }
}

export default ChangeDeviceStatus;
